require('./bootstrap');

Helper.ready(() => {
    'use strict';

    const body = document.body;
    const selectElements = document.querySelectorAll('.select[data-toggle="select-collapse"]');

    // Fade out global page overlay
    Fnc.showGlobalOverlay(body);

    // Initialize libraries
    Init.initContainer(body);

    // Hide mobile menu on desktop view
    const hideMobileMenuInDesktop = () => {
        if (window.innerWidth >= 940 && document.getElementById('menu-popup').offsetHeight !== 0) {
            document.querySelectorAll('.menu-hamburger').forEach(element => {
                element.classList.remove('active');
            });

            body.classList.remove('overflow-hidden');

            document.querySelectorAll('.pop-up-meniu').forEach(element => {
                element.classList.remove('show');
                element.classList.add('hide');
                element.style.display = 'none';
            });
        }
    };

    window.addEventListener('resize', hideMobileMenuInDesktop);
    window.dispatchEvent(new Event('resize'));

    // Close alert on click
    document.addEventListener('click', event => {
        if (event.target.classList.contains('close') || event.target.parentElement.classList.contains('close')) {
            const alert = event.target.closest('.alert');
            if (alert) alert.remove();
        }
    });

    // Handle select elements with data-toggle="select-collapse"
    selectElements.forEach(selectEl => {
        Fnc.handleSelectCollapse(selectEl);

        selectEl.addEventListener('change', function () {
            Fnc.handleSelectCollapse(this);
        });
    });

    // Toggle mobile menu visibility
    document.querySelector('.menu-hamburger')?.addEventListener('click', function () {
        const popup = document.querySelector('.pop-up-meniu');
        if (popup) {
            this.classList.toggle('active');
            body.classList.toggle('overflow-hidden');
            popup.classList.toggle('show');
            popup.classList.toggle('hide');
        }
    });

    /**
     * The ID of the interval timer returned by `setInterval`. This interval is used to
     * repeatedly check for the presence of form elements in the DOM every 100 milliseconds.
     * Once the form elements are detected and initialized, the interval is cleared using
     * this ID to stop further checks.
     * @type {number}
     */
    const checkInitialization = setInterval(() => {
        // Ensure that form elements are available
        const form = document.querySelector('form.form-validate');

        if (form) {
            // Initialize validation for first form element
            Validate.initializeValidation(document);

            if (form.closest('.addCaptcha')) {
                // For forms with 'addCaptcha' class
                Fnc.loadRecaptchaApi();
                Fnc.submitForm(function (button, form, event) {
                    Fnc.handleRecaptchaOnSubmit(button, form, event);
                });
            } else {
                // For forms without 'addCaptcha' class
                Fnc.submitForm();
            }

            // Clear the interval once initialization is done
            clearInterval(checkInitialization);
        }
    }, 100);

    // Might be not needed: Timeout to prevent indefinite checking
    setTimeout(() => clearInterval(checkInitialization), 1000);
});

/**
 * This function sets the input values based on the controlling input's state.
 * It handles dependent fields, storing original values and switching to anonymous values if necessary.
 * Also disables certain inputs based on the controlling input's state.
 * @param controllingInput
 * @param formInputs
 * @param storedValues
 * @param isEnabled
 * @param tickets
 */
function setInputValues(controllingInput, formInputs, storedValues, isEnabled, tickets) {
    Object.keys(formInputs).forEach(field => {
        const isRegisteredUser = formInputs[field].dataset.disableIfLoggedIn === 'true';
        if (isEnabled) {
            // Store original value before changing to anonymous only if it's not already anonymous
            if (formInputs[field].value !== formInputs[field].dataset.dependentValue) {
                storedValues[field] = formInputs[field].value;
            }
            // Set anonymous values if they exist for the field
            formInputs[field].value = formInputs[field].dataset.dependentValue || '';
        } else if (storedValues[field] !== undefined) {
            // Restore original values when the control is deactivated (unchecked or empty)
            formInputs[field].value = storedValues[field];
        }
        // Set the disable status
        formInputs[field].disabled = isRegisteredUser ? true : isEnabled;
    });

    // Toggle the visibility of ticket elements based on controlling input's state
    tickets.forEach(ticket => ticket.style.display = isEnabled ? 'none' : 'block');
}

/**
 * Handle changes for any input that controls dependent fields.
 * This function listens to input changes for elements with 'data-depend-id' and updates
 * dependent fields accordingly.
 *
 * @param controllingInput
 */
function handleDependentChange(controllingInput) {
    const form = controllingInput.form;

    const formInputs = {};
    const storedValues = {};

    // Retrieve input fields that depend on the controlling input
    Array.from(form.querySelectorAll(`[data-depend-on="${controllingInput.dataset.dependId}"]`)).forEach(input => {
        const field = input.name;
        formInputs[field] = input;
        storedValues[field] = input.value || '';
    });

    const tickets = document.querySelectorAll('.tickets-wrapper');

    // Add event listener for input changes to handle dependent updates
    controllingInput.addEventListener('input', function () {
        const isEnabled = controllingInput.type === 'checkbox' ? controllingInput.checked : controllingInput.value !== '';

        setInputValues(controllingInput, formInputs, storedValues, isEnabled, tickets);
    });
}

// Initialize the dependent fields logic for any input with data-depend-id
document.addEventListener('DOMContentLoaded', function () {
    const controllingInputs = document.querySelectorAll('[data-depend-id]');

    controllingInputs.forEach(controllingInput => {
        handleDependentChange(controllingInput);
    });
});
